export default "__VITE_ASSET__BBvEziET__"